import { apiSuperModels } from '@spo/services/api';
import { PatchApiSpoSmBody } from '@spo/types';
import { useQuery } from '@tanstack/react-query';

export const useSuperModelsMassEdit = (
  patchApiSpoSmBody: PatchApiSpoSmBody,
) => {
  return useQuery({
    queryKey: ['useSuperModelsMassEdit', patchApiSpoSmBody],
    queryFn: () => apiSuperModels.updateSuperModels(patchApiSpoSmBody),
    enabled:
      patchApiSpoSmBody.smMassEdit && patchApiSpoSmBody.smMassEdit.length > 0,
  });
};
